<template>
  <section class="atom-simple-text">
    <el-input v-model="simpleText" @change="$emit('input', { text: simpleText })"></el-input>
  </section>
</template>

<script>

export default {
  name: 'AtomSimpleText',
  props: ['value'],
  data() {
    return {
      simpleText: null,
    };
  },
  mounted() {
    this.simpleText = this.value.text;
  },
  methods: {
  },
};
</script>

<style lang="sass">
.atom-simple-text
  padding: 2rem 1rem

  // div[contenteditable]
  //   padding: 0
  //   &:focus
  //     outline: 0

  .text-container
    position: relative

  .popin
    position: absolute
    margin-top: 0px
    padding: 0.1rem 0 0.05rem
    width: 92px
    background: #ff3c48
    border-radius: 2px
    transform: translateX(-50px) translateY(100%)
    z-index: 1500
    &:after
      content: ""
      position: absolute
      top: -6px
      left: 50%
      margin-left: -7px
      width: 0
      height: 0
      border-style: solid
      border-width: 0 10px 10px 10px
      border-color: transparent transparent #ff3c48 transparent
      transform: rotate(15deg)
    button
      margin: 0
      padding: 0.4rem 0.5rem
      background: transparent
      color: white
      border: none
      border-radius: 0
      & ~ button
        border-left: 1px solid white
      i
        font-size: 0.85rem

</style>
